import { pageInfoTypes } from '../constants';

export const setPageInfo = (info = {}) => ({
  type: pageInfoTypes.SET_PAGE_INFO,
  info
});

export const setLps = (lps = '') => ({
  type: pageInfoTypes.SET_LPS,
  lps
});
